<div class="tour-booking-widget">
  <!-- Error Messages -->
  @if (error.widget) {
    <div class="error-message">{{ error.widget }}</div>
  }
  @if (error.availability) {
    <div class="error-message">{{ error.availability }}</div>
  }
  @if (error.submission) {
    <div class="error-message" role="alert" aria-label="submission-error">{{ error.submission }}</div>
  }

  

  @if (success) {
    <div class="success-message">
      <h3>Tour Booking Confirmed!</h3>
      <p>Thank you for booking a tour. We'll be in touch shortly with more details.</p>
    </div>
  }

  @if (!success) {
    <div class="booking-container">
      <!-- Left Column - Lead Form -->
      <div class="form-column" #formColumn>
        @if (widgetId()) {
          <ufp-lead-capture-v2
            [widgetId]="widgetId()"
            [tourBookingEmbed]="true"
            [defaultTenantUuid]="selectedTenantUuid ?? ''"
            (tourFormCompleteChange)="onTourFormCompleteChange($event)"
            (tenantChange)="onTenantChange($event)"
            #leadCapture>
          </ufp-lead-capture-v2>
        }
      </div>

      <!-- Right Column - Date and Time Selection -->
      <div class="slot-column" #slotColumn>
        <div class="date-selection">
          <h3>Select a Date</h3>
          <div class="date-scroller">
            <button
              class="scroll-button"
              (click)="scrollDates('prev')"
              [disabled]="dateScrollIndex === 0">
              &lt;
            </button>

            <div class="dates">
              @for (date of dates; track $index; let i = $index) {
                <div
                  class="date-item"
                  [class.selected]="selectedDateIndex === i"
                  [class.hidden]="!date.isVisible"
                  (click)="onDateSelect(i)">
                  <div class="day-name">{{ date.dayName }}</div>
                  <div class="day-number">{{ date.dayNumber }}</div>
                  <div class="month-name">{{ date.monthName }}</div>
                </div>
              }
            </div>

            <button
              class="scroll-button"
              (click)="scrollDates('next')"
              [disabled]="dateScrollIndex + visibleDatesCount >= dates.length">
              &gt;
            </button>
          </div>
        </div>

        @if (loading.availability) {
          <div class="loading-indicator">
            Loading available slots...
          </div>
        }

        @if (availableSlots.length > 0 && !loading.availability) {
          <div class="time-selection">
            <h3>Select a Time</h3>
            <div class="time-slots">
              @for (slot of availableSlots; track slot) {
                <button
                  class="time-slot"
                  [class.selected]="selectedSlot === slot"
                  (click)="onSlotSelect(slot)">
                  {{ formatTimeSlot(slot) }}
                </button>
              }
            </div>
          </div>
        }

        @if (availableSlots.length === 0 && !loading.availability) {
          <div class="no-slots-message">
            <p>No available time slots for the selected date. Please choose another date.</p>
          </div>
        }
      </div>
    </div>
  }

  <!-- Submit Button Section - Only visible when not successful and form is filled -->
  @if (!success) {
    <div
      class="submit-section widget-submit-section"
      [class.disabled]="!canSubmit && !recaptchaFlow.showV2Challenge()">
      @if (recaptchaFlow.showV2Challenge()) {
        <ufp-widget-recaptcha-v2-section
          [hint]="recaptchaV2Hint"
          (resolved)="onRecaptchaV2Resolved($event)"
          (failed)="onRecaptchaV2Failed()"
        />
      }
      <button
        class="submit-button"
        (click)="onSubmit()"
        [disabled]="loading.submission || !canSubmit || recaptchaFlow.showV2Challenge()"
        aria-label="book-tour">
        {{ loading.submission ? 'Booking Tour...' : 'Book Tour' }}
      </button>
    </div>
  }

  <!-- Loading Overlay only during submission -->
  <ufp-widget-processing-overlay
    [visible]="loading.submission && !recaptchaFlow.showV2Challenge()"
    message="Processing your booking..."
  />
</div>
